import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";
import ContentLoader from "react-content-loader";

import createLink from "../../../libs/createLink";
import Aqp from "../../../libs/mk-react-aqp";

import {fetchTopUsers} from '../../../creators/users';

import Avatar from '../../components/Avatar';
import Carousel from '../../components/Carousel';
import Title from "../../components/Title";
import {PageLoader} from "../../components/Loader";
import DateSince from "../../components/Date";
import {Button} from "../../components/Button";

class TopUsers extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            // gender: false,
            limit: 30,
            page: 1,
            sort: 0
        };
        this.aqp = new Aqp({}, {
            blacklist: ['limit', 'page'],
            currentLink: "/top-users",
            filterDefault: this.filter
        });
        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: this.props.match.params.page || 1},
        };

        this.handleChangePaneIndex = this.handleChangePaneIndex.bind(this);
        this.getTopUsers = this.getTopUsers.bind(this);
        this.prevUsers = this.prevUsers.bind(this);
        this.nextUsers = this.nextUsers.bind(this);

        this.getTopUsers(this.state.filter);
    }

    getTopUsers(filter, more) {
        filter = {...filter};
        this.props.fetchTopUsers(this.aqp.set(filter), more);
    }

    handleChangePaneIndex(index) {
        let filter = {...this.state.filter, sort: index, page: 1};
        this.setState({filter});
        this.getTopUsers(filter, false);
    }

    prevUsers() {
        let page = parseInt(this.state.filter.page) - 1;
        let newFilter = {...this.state.filter, page};
        this.setState({filter: newFilter});
        this.getTopUsers(newFilter, true);
    }

    nextUsers() {
        let page = parseInt(this.state.filter.page) + 1;
        let newFilter = {...this.state.filter, page};
        this.setState({filter: newFilter});
        this.getTopUsers(newFilter, true);
    }

    tplList(item) {
        return this.props.usersLoading ? (
            <ContentLoader
                height={80}
                width={1200}
                speed={2}
                primaryColor="#f3f3f3"
                secondaryColor="#ecebeb"
                key={item._id}
            >
                <circle cx="60" cy="45" r="30" />
                <rect x="105" y="20" rx="5" ry="5" width="250" height="12" />
                <rect x="105" y="40" rx="5" ry="5" width="180" height="12" />
                <rect x="105" y="60" rx="5" ry="5" width="125" height="12" />
            </ContentLoader>
        ) : (
            <div className="user" key={item._id}>
                <Avatar gender={item.profile.gender} avatar={item.profile.avatar}/>
                <div className="infos">
                    <span className="username"><Link to={createLink("userProfile", item)}>{item.username}</Link></span>
                    <span className="sub-infos">
                        <DateSince
                            date={item.createdAt}
                            prefix={false}
                            currentFormat={false}
                        />
                    </span>
                    <span className="sub-infos">{item.role} · {(item.count && item.count.comment) || 0} messages</span>
                </div>
            </div>
        )
    }

    render() {
        return !this.props.usersInitialized ? (
            <div id="topUsers">
                <div className="container">
                    <div className="main-wrapper">
                        <PageLoader/>
                    </div>
                </div>
            </div>
        ) : (
            <div id="topUsers">
                <div className="container">
                    <div className="main-wrapper">
                        <h3>Liste des membres</h3>
                        <div className="card-controls">
                            <Title heading={"heading-2"}>
                                <span className={this.state.filter.sort === 0 ? 'active' : ''}
                                      onClick={() => this.handleChangePaneIndex(0)}>Nom du membre</span>
                                <span className={this.state.filter.sort === 1 ? 'active' : ''}
                                      onClick={() => this.handleChangePaneIndex(1)}>Nombre de messages</span>
                                <span className={this.state.filter.sort === 2 ? 'active' : ''}
                                      onClick={() => this.handleChangePaneIndex(2)}>Date d'inscription</span>
                            </Title>
                        </div>
                        <Carousel hideArrowsControls={true} currentPaneIndex={this.state.filter.sort}>
                            <div className={`pane ${this.state.filter.sort === 0 ? 'active' : ''}`}>
                                <div className="list">
                                    <div className={"top-user-pagination"}>
                                        {this.state.filter.page > 1 && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.prevUsers()}
                                                    content={"précédent"} />
                                        )}
                                        {this.props.usersMore && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.nextUsers()}
                                                    content={"Suivant"} />
                                        )}
                                    </div>
                                    {this.props.users.map((item) => this.tplList(item))}
                                    <div className={"top-user-pagination"}>
                                        {this.state.filter.page > 1 && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.prevUsers()}
                                                    content={"précédent"} />
                                        )}
                                        {this.props.usersMore && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.nextUsers()}
                                                    content={"Suivant"} />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`pane ${this.state.filter.sort === 1 ? 'active' : ''}`}>
                                <div className="list">
                                    <div className={"top-user-pagination"}>
                                        {!this.props.usersLoading && this.state.filter.page > 1 && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.prevUsers()}
                                                    content={"précédent"} />
                                        )}
                                        {!this.props.usersLoading && this.props.usersMore && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.nextUsers()}
                                                    content={"Suivant"} />
                                        )}
                                    </div>
                                    {this.props.users.map((item) => this.tplList(item))}
                                    <div className={"top-user-pagination"}>
                                        {!this.props.usersLoading && this.state.filter.page > 1 && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.prevUsers()}
                                                    content={"précédent"} />
                                        )}
                                        {!this.props.usersLoading && this.props.usersMore && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.nextUsers()}
                                                    content={"Suivant"} />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`pane ${this.state.filter.sort === 2 ? 'active' : ''}`}>
                                <div className="list">
                                    <div className={"top-user-pagination"}>
                                        {!this.props.usersLoading && this.state.filter.page > 1 && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.prevUsers()}
                                                    content={"précédent"} />
                                        )}
                                        {!this.props.usersLoading && this.props.usersMore && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.nextUsers()}
                                                    content={"Suivant"} />
                                        )}
                                    </div>
                                    {this.props.users.map((item) => this.tplList(item))}
                                    <div className={"top-user-pagination"}>
                                        {!this.props.usersLoading && this.state.filter.page > 1 && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.prevUsers()}
                                                    content={"précédent"} />
                                        )}
                                        {!this.props.usersLoading && this.props.usersMore && (
                                            <Button size="small"
                                                    btnStyle="primary-reverse"
                                                    onClick={()=> this.props.usersLoading ? null : this.nextUsers()}
                                                    content={"Suivant"} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        users: state.users.data,
        usersLoading: state.users.loading,
        usersInitialized: state.users.initialized,
        usersTotal: state.users.total,
        usersMore: state.users.more
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchTopUsers
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(TopUsers);
